export default [
  { label: 'Welcome Reception', value: 'Welcome Reception' },
  { label: 'Golf Tournament', value: 'Golf Tournament' },
  { label: 'Memorial Service', value: 'Memorial Service' },
  { label: 'P-Rade', value: 'P-Rade' },
  { label: 'Social', value: 'Social' },
  { label: 'Prayer Breakfast', value: 'Prayer Breakfast' },
  { label: 'Class Meeting', value: 'Class Meeting' },
  { label: 'Football Game/Tailgate', value: 'Football Game/Tailgate' },
  { label: 'Company Parties', value: 'Company Parties' },
  { label: 'Miscellaneous/Yard Photos', value: 'Miscellaneous/Yard Photos' },
  { label: 'Sunday Farewell Brunch', value: 'Sunday Farewell Brunch' }
]
